import clsx from "clsx"
import { FC } from "react"
import { getDurabilityFill, getDurabilityStyle } from "@/helpers/durability"
import styles from "./DurabilityBar.module.scss"

export const DurabilityBar: FC<{ current: number; max: number }> = ({
  current,
  max
}) => {
  const fill = getDurabilityFill(current, max)
  return (
    <div
      className={clsx(styles.DurabilityBar, { [styles.broken]: fill === 0 })}
      style={getDurabilityStyle(fill)}
    >
      <div
        className={styles.DurabilityBar_fill}
        style={{ width: `${fill * 100}%` }}
      />
      <span className={styles.DurabilityBar_text}>
        {current} / {max}
      </span>
    </div>
  )
}
